import { render, staticRenderFns } from "./home-h5.vue?vue&type=template&id=276bed85&scoped=true&"
import script from "./home-h5.vue?vue&type=script&lang=js&"
export * from "./home-h5.vue?vue&type=script&lang=js&"
import style0 from "./home-h5.vue?vue&type=style&index=0&id=276bed85&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276bed85",
  null
  
)

export default component.exports